import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { clsx } from "clsx";
import { Loader2 } from "lucide-react";
import { garmentHex } from "@erc/shared";
import { customApi, type CustomListingDetail } from "../../lib/customListing";

// Ornek (tasarim) sirasi: mockuplara denk gelen tasarim bu siradan gelir (5. ve 6. adim).
// afterSave: sira kaydedilince basilan mockuplari yeniden basar.

export function SampleOrder({ rec, hint, afterSave, onChanged, onError }: {
  rec: CustomListingDetail; hint?: string; afterSave?: () => Promise<unknown>; onChanged: () => void; onError: (msg: string) => void;
}) {
  const renders = rec.template.samples?.renders ?? [];
  const [order, setOrder] = useState<string[]>(renders.map((r) => r.id));
  useEffect(() => { setOrder(renders.map((r) => r.id)); }, [renders.map((r) => r.id).join("|")]); // eslint-disable-line react-hooks/exhaustive-deps
  const [drag, setDrag] = useState<number | null>(null);
  const save = useMutation({
    mutationFn: async (ids: string[]) => { await customApi("POST", `/${rec.id}/samples-order`, { ids }); await afterSave?.(); },
    onSuccess: onChanged,
    onError: (e) => onError((e as Error).message),
  });
  const onDrop = (to: number) => {
    if (drag === null || drag === to) return;
    const next = [...order];
    const [m] = next.splice(drag, 1);
    next.splice(to, 0, m);
    setDrag(null); setOrder(next); save.mutate(next);
  };
  if (!renders.length) return null;
  return (
    <div>
      <p className="mb-1.5 text-xs font-medium text-gray-600">
        Tasarımlar ({renders.length}) · sürükleyerek sırala; mockuplardaki tasarımlar bu sırayla dağılır (kumaşta okunmayan tasarım atlanır){hint ?? ""}
        {save.isPending && <Loader2 className="ml-1 inline h-3.5 w-3.5 animate-spin" />}
      </p>
      <div className="grid grid-cols-4 gap-2.5 sm:grid-cols-6 xl:grid-cols-8">
        {order.map((id, i) => {
          const r = renders.find((x) => x.id === id);
          if (!r) return null;
          return (
            <div key={id} draggable={!save.isPending} onDragStart={() => setDrag(i)} onDragOver={(e) => e.preventDefault()} onDrop={() => onDrop(i)}
              className={clsx("relative cursor-move overflow-hidden rounded-lg border-2 border-gray-200", drag === i && "opacity-50")}>
              <img src={r.url} alt="" loading="lazy" className="aspect-square w-full object-contain p-1" style={{ background: garmentHex(r.productColor) }} />
              <span className="absolute left-1 top-1 rounded-full bg-black/60 px-1.5 text-xs font-semibold text-white">{i + 1}</span>
              <span className="absolute bottom-0 left-0 right-0 truncate bg-white/85 px-1 text-[10px] text-gray-700">{r.productColor}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
